import fetch ,{postFrom, getBlob} from "../utils/fetch";


export function incomelist(params) {
  return fetch({
    method:'POST',
    url:'/incomeCostItem/income/list',
    data:params
  })
}
export function editCostAmount(params) {
  return fetch({
    method:'POST',
    url:'/incomeCostItem/cost/editCostAmount',
    data:params
  })
}

export function commissionlist(params) {
  return fetch({
    method:'POST',
    url:'/incomeCostItem/commission/list',
    data:params
  })
}

export function costlist(params) {
  return fetch({
    method:'POST',
    url:'/incomeCostItem/cost/list',
    data:params
  })
}
export function monthscondition(params) {
  return fetch({
    method:'GET',
    url:'/incomeCostItem/months/condition',
    params
  })
}
export function costdeduct(params) {
  return fetch({
    method:'GET',
    url:'/incomeCostItem/cost/deduct',
    params
  })
}


export function goplist(params) {
  return fetch({
    method:'GET',
    url:'/gop/list',
    params
  })
}
export function businessCodecondition(params) {
  return fetch({
    method:'GET',
    url:'/incomeCostItem/businessCode/condition',
    params
  })
}
export function formulaSnapshotdetail(params) {
  return fetch({
    method:'GET',
    url:'/formulaSnapshot/detail',
    params
  })
}

//POST /incomeCostItem/downloadCostList 导出成本明细列表

export function downloadCostList(params) {
  return getBlob({
    method:'POST',
    url:'/incomeCostItem/downloadCostList',
    data:params
  })
}

//incomeCostItem/cost/listPolymerization

export function listPolymerization(params) {
  return fetch({
    method:'POST',
    url:'/incomeCostItem/cost/listPolymerization',
    data:params
  })
}

///incomeCostItem/downloadPolymerizationCostList //导出聚合成本明细
export function downloadPolymerizationCostList(params) {
  return getBlob({
    method:'POST',
    url:'/incomeCostItem/downloadPolymerizationCostList',
    data:params
  })
}

//incomeCostItem/exportOrtherIncome

export function exportOrtherIncome(params) {
  return getBlob({
    method:'POST',
    url:'/incomeCostItem/exportOrtherIncome',
    data:params
  })
}

//incomeCostItem/businessCode/FzFwf
export function getFzFwf(params) {
  return fetch({
    method:'GET',
    url:'/incomeCostItem/businessCode/FzFwf',
    params
  })
}
